import { styledDs as styled } from '../../styles/theme';

export const Container = styled.div`
  position: fixed;
  inset: 0;
  z-index: 1000;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: ${({ theme }) => theme.space.xxl};
  /*
   * O gradiente de marca nos dois temas, e não a cor da página: é a mesma razão
   * do painel da tela de entrada — esta é uma peça de marca, e sobre ela a
   * assinatura é branca.
   */
  background: ${({ theme }) => theme.gradiente};
  color: #ffffff;
`;

export const Logo = styled.div`
  height: 80px;
  width: 80px;

  .logo {
    transform: scale(0.4);
    stroke-dasharray: 850;
    stroke-dashoffset: 850;
    animation: desenharMarca 4s linear forwards infinite;
  }

  /* Partes da marca compartilhada; a escala é a mesma da outra silhueta. */
  .arco {
    transform: scale(0.4);
    stroke-dasharray: 850;
    stroke-dashoffset: 850;
    animation: desenharInside 4s linear forwards infinite;
  }

  .ponto {
    transform: scale(0.4);
    animation: acenderPonto 4s linear forwards infinite;
  }

  @keyframes desenharMarca {
    5% {
      stroke-dashoffset: 850;
    }
    40%,
    60% {
      stroke-dashoffset: 0;
    }
    95% {
      stroke-dashoffset: 850;
    }
  }

  @keyframes desenharInside {
    15% {
      stroke-dashoffset: 850;
    }
    50% {
      stroke-dashoffset: 0;
    }
    85% {
      stroke-dashoffset: 850;
    }
  }

  @keyframes acenderPonto {
    0%,
    100% {
      opacity: 0;
    }
    10%,
    90% {
      opacity: 1;
    }
  }
`;

export const Slider = styled.div`
  position: relative;
  width: min(280px, 60vw);
  height: 3px;
  overflow: hidden;
  border-radius: ${({ theme }) => theme.radius.pill};
  background: rgba(255, 255, 255, 0.16);
`;

export const Barra = styled.div`
  position: absolute;
  top: 0;
  height: 100%;
  width: 40%;
  border-radius: inherit;
  background: ${({ theme }) => theme.colors.marca};
  animation: percorrer 1.4s ease-in-out infinite;

  @keyframes percorrer {
    from {
      left: -40%;
    }
    to {
      left: 100%;
    }
  }
`;
